import { Injectable } from '@angular/core';
import { DropDownModel } from '@app/pages/customer/models/dropdown.model';
import { TenantModel } from '@app/shared/models/tenant.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Api } from './api.service';
import { BaseService } from './base.service';

@Injectable()
export class TenantService extends BaseService {
    controllerName = 'api/tenant';

    constructor(protected api: Api) {
        super(api, 'api/tenant');
    }

    public isValid(): Observable<boolean> {
        return this.api.get(`${this.controllerName}/isvalid`);
    }

    public isValidSubdomain(subdomain: string, id: number = 0): Observable<boolean> {

        return this.api.get(`${this.controllerName}/is-valid/${subdomain}?id=${id}`);
    }

    public create(data: TenantModel) {
        return this.api.post(`${this.controllerName}`, data);
    }

    public edit(data: TenantModel) {
        return this.api.put(`${this.controllerName}`, data);
    }
    public getListTenantsBussinessName(): Observable<any[]> {
        return this.api.get(`${this.controllerName}/get-all-bussiness-name`);
    }

    public getListTenantsName(): Observable<string[]> {
        return this.api.get(`${this.controllerName}/get-all-subdomain`);
    }
    public getById(id: number) {
        return this.api.get(`${this.controllerName}/${id}`);
    }

    public getSetting() {
        return this.api.get(`${this.controllerName}/get-setting`);
    }

    public isResyncQuickbook() {
        return this.api.get(`${this.controllerName}/is-resync-quickbook`);
    }

    public resyncQuickbook() {
        return this.api.put(`${this.controllerName}/resync-quickbook`, null);
    }

    getDropDownData(type: string) : Observable<Array<DropDownModel>> {
        return this.getData(`${this.controllerName}/dropdown/${type}`)
            .pipe(map((list: Array<any>) => {
                let result = new Array<DropDownModel>()
                list.forEach(item => {
                    result.push(new DropDownModel(item));
                });
                return result;
            }));
    }
    
    getTypeByTenant(tenant: string, type: string) {
        return this.getData(`${this.controllerName}/dropdown/${type}/${tenant}`);
    }
}
